import { render, staticRenderFns } from "./AppTeamMembersList.vue?vue&type=template&id=a33b1d18"
import script from "./AppTeamMembersList.vue?vue&type=script&lang=js"
export * from "./AppTeamMembersList.vue?vue&type=script&lang=js"
import style0 from "./AppTeamMembersList.vue?vue&type=style&index=0&id=a33b1d18&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports